import httpCommon from "./http-common";

// Get customer
const getCustomer = (publicId: string) => {
  return httpCommon.get(`/v1/get/customer/${publicId}`);
};

// Get all customers
const getAllCustomers = (businessId: number) => {
  return httpCommon.get(`/v1/get/customers/${businessId}`);
};

// Get customer count
const getAllCustomersCount = () => {
  return httpCommon.get("/v1/get/count/customers");
};

const getCustomerRoles = () => {
  return httpCommon.get("/v1/get/customerRoles");
};

const getCustomerRolesForCustomer = (customerId: number) => {
  return httpCommon.get(`/v1/get/customerRoles/${customerId}`);
};

const getTransactionCustomersByCustomerId = (customerId: number) => {
  return httpCommon.get(`/v1/get/transactionCustomers/${customerId}`);
};

// Add customer
const addCustomer = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/customer/${businessId}`, data);
};

const createCustomerRole = (data: any, customerId: number) => {
  return httpCommon.post(`/v1/add/customerRole/${customerId}`, data);
};

const searchCustomer = (businessId: number, searchTerm: string) => {
  return httpCommon.get(`/v1/search/customers/${businessId}/${searchTerm}`);
};

// Update specific customer
const updateSpecificCustomer = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/customer/${id}`, data);
};

// Update self customer
const updateCustomer = (data: any) => {
  return httpCommon.put(`/v1/update/customer`, data);
};

// Delete customer
const deleteCustomer = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/customer/${publicId}`);
};

const deleteCustomerRole = (roleId: number) => {
  return httpCommon.delete(`/v1/delete/customerRole/${roleId}`);
};

// Admin functions
const getCustomerAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/customer");
};

const getAllCustomersAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/customers");
};

const getAllCustomersCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/customers");
};

const getCustomerRolesAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/customerRoles");
};

const getCustomerRolesForCustomerAsAdminUser = (customerId: number) => {
  return httpCommon.get(`/v1/admin/get/customerRoles/${customerId}`);
};

const addCustomerAsAdminUser = (data: any) => {
  return httpCommon.post("/v1/admin/add/customer", data);
};

const createCustomerRoleAsAdminUser = (data: any, customerId: number) => {
  return httpCommon.post(`/v1/admin/add/customerRole/${customerId}`, data);
};

const updateSpecificCustomerAsAdminUser = (id: number, data: any) => {
  return httpCommon.put(`/v1/admin/update/customer/${id}`, data);
};

const updateCustomerAsAdminUser = (data: any) => {
  return httpCommon.put(`/v1/admin/update/customer`, data);
};

const deleteCustomerAsAdminUser = (id: number) => {
  return httpCommon.delete(`/v1/admin/delete/customer/${id}`);
};

const deleteCustomerRoleAsAdminUser = (roleId: number) => {
  return httpCommon.delete(`/v1/admin/delete/customerRole/${roleId}`);
};

const CustomerService = {
    getCustomer,
    getAllCustomers,
    getAllCustomersCount,
    getCustomerRoles,
    getCustomerRolesForCustomer,
    addCustomer,
    createCustomerRole,
    updateSpecificCustomer,
    updateCustomer,
    searchCustomer,
    deleteCustomer,
    deleteCustomerRole,
    getCustomerAsAdminUser,
    getAllCustomersAsAdminUser,
    getAllCustomersCountAsAdminUser,
    getCustomerRolesAsAdminUser,
    getCustomerRolesForCustomerAsAdminUser,
    addCustomerAsAdminUser,
    createCustomerRoleAsAdminUser,
    updateSpecificCustomerAsAdminUser,
    updateCustomerAsAdminUser,
    deleteCustomerAsAdminUser,
    deleteCustomerRoleAsAdminUser
};
export default CustomerService;